<template>
  <div class="ovg-form">
    <p class="ovg-hint">
      Verifica que la información ingresada sea correcta antes de generar tu
      registro. Podrás modificar cualquier dato si lo necesitas.
    </p>

    <div class="ovg-summary">
      <h3 class="ovg-section-title">Datos del Cliente:</h3>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label ovg-summary__label--accent">R.U.T</p>
          <p class="ovg-summary__value">{{ dataClient.rut }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Nombre</p>
          <p class="ovg-summary__value">{{ dataClient.nombre }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Apellido</p>
          <p class="ovg-summary__value">{{ dataClient.apellido }}</p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Correo Electrónico</p>
          <p class="ovg-summary__value">{{ dataClient.email }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Teléfono</p>
          <p class="ovg-summary__value">{{ dataClient.telefono || '-' }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Región</p>
          <p class="ovg-summary__value">{{ dataClient.region }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Comuna</p>
          <p class="ovg-summary__value">{{ dataClient.comuna }}</p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item ovg-summary__item--full">
          <p class="ovg-summary__label">Dirección de la Calle</p>
          <p class="ovg-summary__value">{{ dataClient.direccion }}</p>
        </div>
      </div>
    </div>

    <div class="ovg-summary">
      <h3 class="ovg-section-title">Datos del Equipo:</h3>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label ovg-summary__label--accent">Modelo</p>
          <p class="ovg-summary__value">{{ dataEquipment.model_name }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Número de Serie</p>
          <p class="ovg-summary__value">
            {{ dataEquipment.serial_number || '-' }}
          </p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Password</p>
          <p class="ovg-summary__value">{{ dataEquipment.password || '-' }}</p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Cargador</p>
          <p class="ovg-summary__value">
            {{ textoOpcion(chargerOptions, dataEquipment.power_source) }}
          </p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Disco Duro</p>
          <p class="ovg-summary__value">
            {{ textoOpcion(hardDriveOptions, dataEquipment.size_hard_drive) }}
          </p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">RAM</p>
          <p class="ovg-summary__value">
            {{ textoOpcion(ramOptions, dataEquipment.total_ram_memorie) }}
          </p>
        </div>
      </div>
    </div>

    <div class="ovg-summary">
      <h3 class="ovg-section-title">Datos de la Falla:</h3>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Tipo de Servicio</p>
          <p class="ovg-summary__value">{{ tipoServicioTexto }}</p>
        </div>
        <div v-if="mostrarFechaCompra" class="ovg-summary__item">
          <p class="ovg-summary__label">Fecha de Compra</p>
          <p class="ovg-summary__value">
            {{ getFecha(warrantyFail.fecha_de_compra) }}
          </p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item ovg-summary__item--full">
          <p class="ovg-summary__label">Descripción del Problema</p>
          <p class="ovg-summary__value">
            {{ warrantyFail.reporte_falla_cliente || '-' }}
          </p>
        </div>
      </div>
    </div>

    <div v-if="firma" class="ovg-summary">
      <h3 class="ovg-section-title">Consentimiento:</h3>
      <img
        class="ovg-summary__signature"
        :src="firma.dataUrl"
        alt="Firma del cliente"
      />
    </div>

    <div class="ovg-card__footer ovg-card__footer--between">
      <button type="button" class="ovg-btn ovg-btn--secondary" @click="goBack">
        Paso Anterior
      </button>
      <button
        type="button"
        class="ovg-btn ovg-btn--primary"
        :disabled="loading"
        @click="save"
      >
        Confirmar Pre-Ingreso
      </button>
    </div>

    <div v-if="showModal" class="ovg-modal-backdrop" @click.self="finish">
      <div class="ovg-modal" role="dialog" aria-modal="true">
        <div class="ovg-modal__header">
          <h3 class="ovg-modal__title">¡Pre-ingreso registrado con éxito!</h3>
          <button
            type="button"
            class="ovg-modal__close"
            aria-label="Cerrar"
            @click="finish"
          >
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <font-awesome-icon class="ovg-modal__icon" icon="check-circle" />
        <p class="ovg-modal__text">
          Te hemos enviado un correo electrónico con el resumen de tu solicitud
          y las instrucciones exactas para embalar y despachar tu equipo hacia
          nuestra sucursal de forma segura.
        </p>
        <p class="ovg-modal__text ovg-modal__text--note">
          Por favor, revisa tu bandeja de entrada o carpeta de spam antes de
          enviar tu equipo.
        </p>
        <button type="button" class="ovg-btn ovg-btn--primary" @click="finish">
          Volver al inicio
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import {
  chargerOptions,
  hardDriveOptions,
  ramOptions,
} from '../../NewOT/options'
import {
  TIPO_SERVICIO_GARANTIA,
  TIPO_SERVICIO_PRESUPUESTO,
  dataUrlToBlob,
} from './consentimiento'

const sinSeleccion = (valor) => (valor === '' ? null : valor)

export default {
  name: 'ResumeRegions',
  props: ['dataClient', 'warrantyFail', 'boleta', 'dataEquipment', 'firma'],
  data() {
    return {
      showModal: false,
      loading: false,
      chargerOptions,
      hardDriveOptions,
      ramOptions,
    }
  },
  computed: {
    tipoServicioTexto() {
      if (this.warrantyFail.tipo_servicio === TIPO_SERVICIO_GARANTIA) {
        return 'Garantía'
      }
      if (this.warrantyFail.tipo_servicio === TIPO_SERVICIO_PRESUPUESTO) {
        return 'Presupuesto'
      }
      return '-'
    },
    mostrarFechaCompra() {
      return (
        this.warrantyFail.tipo_servicio === TIPO_SERVICIO_GARANTIA &&
        this.warrantyFail.fecha_de_compra
      )
    },
  },
  methods: {
    ...mapActions('PreIngreso', ['sendPreIngressRegions']),
    goBack() {
      this.$emit('goBack')
    },
    getFecha(fecha) {
      return moment(fecha).format('DD-MM-YYYY')
    },
    textoOpcion(opciones, valor) {
      const opcion = opciones.find((o) => o.value === sinSeleccion(valor))
      return opcion ? opcion.text : '-'
    },
    async save() {
      this.loading = true
      try {
        const equip = {
          serial_number: this.dataEquipment.serial_number,
          password: this.dataEquipment.password,
          size_hard_drive: sinSeleccion(this.dataEquipment.size_hard_drive),
          power_source: sinSeleccion(this.dataEquipment.power_source),
          total_ram_memorie: sinSeleccion(this.dataEquipment.total_ram_memorie),
          model_name: this.dataEquipment.model_name,
          modelo: this.dataEquipment.modelo,
        }
        const otData = {
          datos_provisorios: this.dataClient,
          ...this.warrantyFail,
          equip,
        }
        const formData = new FormData()
        formData.append('ot_data', JSON.stringify(otData))
        if (this.boleta) {
          formData.append('boleta', this.boleta)
        }
        if (this.firma) {
          formData.append(
            'firma_consentimiento',
            dataUrlToBlob(this.firma.dataUrl),
            'firma.png'
          )
        }
        await this.sendPreIngressRegions(formData)
        this.showModal = true
      } catch (error) {
        this.$bvToast.toast(`Error en el ingreso de información: ${error}`, {
          variant: 'danger',
        })
      }
      this.loading = false
    },
    finish() {
      this.$emit('finish')
      this.showModal = false
    },
  },
}
</script>
